import { makeImmutable } from "../../core";
export class PackagingFeeType {
    constructor(params) {
        this.id = params.id;
        this.name = params.name;
        this.requirements = params.requirements;
        this.price = params.price;
        this.deposit = params.deposit;
        this.addedAt = params.addedAt;
        makeImmutable(this);
    }
}
